import { UseCase } from "../UseCase";
import { SessionRepository } from '../../repositories/SessionRepository';

export class PosHasUsersUseCase implements UseCase<string, { pos_has_users: boolean; pos_has_2fa: boolean }> {

    constructor(
        private sessionRepo:SessionRepository
    ){
    }
    
    execute(t: string): Promise<{ pos_has_users: boolean; pos_has_2fa: boolean }> {
        return this.sessionRepo.posHasUsers(t);
      }

}